// Club ordering + colours for the golf activity summary. Order: Driver, woods (low→high),
// hybrids (low→high), irons (low→high), then wedges by loft (PW, GW, SW, LW).

const WEDGE_ORDER: Record<string, number> = {
  pitching: 0,
  gap: 1,
  approach: 1,
  sand: 2,
  lob: 3,
};

/** Sortable rank: category (0 Driver … 4 wedge … 5 unknown) * 100 + within-category number. */
export function clubRank(club: string): number {
  const c = club.trim().toLowerCase();
  if (c === 'driver') return 0;
  let m = c.match(/(\d+)\s*wood/);
  if (m) return 100 + Number(m[1]);
  m = c.match(/(\d+)\s*hybrid/);
  if (m) return 200 + Number(m[1]);
  m = c.match(/(\d+)\s*iron/);
  if (m) return 300 + Number(m[1]);
  for (const [key, ord] of Object.entries(WEDGE_ORDER)) {
    if (c.includes(key) && c.includes('wedge')) return 400 + ord;
  }
  return 500;
}

/** Order a set of club names per the spec. */
export function orderClubs(clubs: string[]): string[] {
  return [...clubs].sort((a, b) => clubRank(a) - clubRank(b) || a.localeCompare(b));
}

// Warm Driver→wedge palette matching the launch-monitor reference.
const CLUB_COLORS: Record<string, string> = {
  driver: '#c026d3',
  '1 wood': '#c026d3',
  '3 wood': '#dc2626',
  '4 wood': '#e11d48',
  '5 wood': '#ef4444',
  '7 wood': '#f87171',
  '2 hybrid': '#ea580c',
  '3 hybrid': '#f97316',
  '4 hybrid': '#fb923c',
  '5 hybrid': '#fdba74',
  '2 iron': '#b45309',
  '3 iron': '#d97706',
  '4 iron': '#f97316',
  '5 iron': '#fb923c',
  '6 iron': '#d97706',
  '7 iron': '#eab308',
  '8 iron': '#facc15',
  '9 iron': '#fde047',
  'pitching wedge': '#4338ca',
  'gap wedge': '#4f46e5',
  'approach wedge': '#4f46e5',
  'sand wedge': '#7c3aed',
  'lob wedge': '#a78bfa',
};

const FALLBACKS = ['#0ea5e9', '#14b8a6', '#10b981', '#84cc16', '#64748b'];

/** Stable colour for a club (known clubs match the reference palette; others hashed). */
export function clubColor(club: string): string {
  const key = club.trim().toLowerCase();
  if (CLUB_COLORS[key]) return CLUB_COLORS[key];
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  return FALLBACKS[h % FALLBACKS.length];
}
